<div class="notice">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>

  <img src="../../../../../assets/images/pre-purchase.png" alt="" />
  <div class="title">购买前请务必阅读</div>
  <div class="subtitle">
      由于个人会员（邀请链接版）的特殊性，为避免后续纠纷，<br />
      请您确认知晓以下规则：
  </div>

  <div class="content" mat-dialog-content>
    <div class="item">
      <div class="txt1"><span></span>不能换绑：</div>
      <div class="txt2">
        加入成功后，您的会员资格将固定在您下单时提供的邮箱，不支持任何形式的换绑、修改。
      </div>
    </div>
    <div class="item">
      <div class="txt1"><span></span>不能暂停：</div>
      <div class="txt2">
        生效后，时长将即刻开始并持续计算。期间不支持暂停、冻结或提前终止。有效期按车票中显示的有效期为准。
      </div>
    </div>
    <div class="item">
      <div class="txt1"><span></span>不支持退款：</div>
      <div class="txt2">
        加入成功后，即视为交易彻底完成。暂不支持退换款及后续售后处理，请确认后再进行支付。
      </div>
    </div>
  </div>

  <label class="checkbox-area" [class.disabled]="countdown > 0">
    <input
      type="checkbox"
      [(ngModel)]="acceptedTerms"
      [disabled]="countdown > 0"
    />
    我已仔细阅读并确认以上规则
  </label>

  <div class="button">
    <button
      matRipple
      [disabled]="countdown > 0 || !acceptedTerms"
      (click)="onOk()"
    >
      我已确认规则，继续支付
      <span *ngIf="countdown > 0">({{ countdown }}s)</span>
    </button>
  </div>
</div>
